import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	IconButton,
	InputAdornment,
	InputLabel,
	MenuItem,
	OutlinedInput,
	TextField,
	Typography,
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { useForm } from "react-hook-form";
import AlertNotistack from "../../components/molecules/AlertNotistack";
import { ReactHookFormSelect } from "../../utils";

export default function FormOnUsers(props) {
	const { open, handleClose, option, fetchAPI } = props;
	const { enqueueSnackbar } = useSnackbar();
	const { register, handleSubmit, errors, control, clearErrors } = useForm();
	const [addChange, setAddChange] = useState({
		role: "",
	});
	const { role } = addChange;
	const [values, setValues] = useState({
		showPassword: false,
	});

	const reset = () => {
		setAddChange({
			...addChange,
			role: "",
		});
		clearErrors();
	};

	const handleClickShowPassword = (event) => {
		setValues({ ...values, showPassword: !values.showPassword });
	};

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	const onSubmit = async (item) => {
		if (validateEmail(item.email)) {
			const data = {
				...item,
				role: role,
			};
			const result = await fetchAPI("add", { ...data });
			if (result.data === "success") reset();
			return result;
		} else {
			return enqueueSnackbar("Email Tidak Valid", AlertNotistack("error"));
		}
	};

	const validateEmail = (email) => {
		const re =
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	};

	return (
		<div>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
			>
				<form onSubmit={handleSubmit(onSubmit)}>
					<DialogTitle id="form-dialog-title">Add On Users</DialogTitle>
					<DialogContent>
						<Grid container spacing={3}>
							<Grid item xs={12} sm={12}>
								<TextField
									id="nama_user"
									name="nama_user"
									label="Nama User "
									error={errors.nama_user}
									fullWidth
									placeholder="Type your Nama user"
									variant="outlined"
									type="string"
									inputRef={register({
										required: {
											value: true,
											message: "Nama tidak boleh kosong",
										},
										minLength: {
											value: 4,
											message: " must be at least 4 alphas",
										},
									})}
									InputLabelProps={{ shrink: true }}
									helperText={errors.nama_user && errors.nama_user.message}
								/>
							</Grid>

							<Grid item xs={12} sm={12}>
								<TextField
									id="username"
									name="username"
									label="Username"
									placeholder="Type your username"
									type="string"
									error={errors.username}
									variant="outlined"
									inputRef={register({
										required: {
											value: true,
											message: "Username tidak boleh kosong",
										},
										minLength: {
											value: 4,
											message: " must be at least 4 alphas",
										},
										pattern: {
											value: /^[a-zA-Z0-9]{4,15}$/,
											message: "Username without Special Character",
										},
									})}
									InputLabelProps={{ shrink: true }}
									helperText={errors.username && errors.username.message}
									fullWidth
								/>
							</Grid>

							<Grid item xs={12} sm={12}>
								<TextField
									id="email"
									name="email"
									label="EMAIL"
									placeholder="Type your EMAIL"
									type="email"
									inputRef={register()}
									error={errors.email}
									variant="outlined"
									required
									InputLabelProps={{ shrink: true }}
									helperText={errors.email && errors.email.message}
									fullWidth
								/>
							</Grid>

							{/* Password */}
							<Grid item xs={12} sm={12}>
								<InputLabel htmlFor="password" shrink error={errors.password}>
									Password
								</InputLabel>
								<OutlinedInput
									id="password"
									name="password"
									label="Password"
									placeholder="Type your password"
									fullWidth
									type={values.showPassword ? "text" : "password"}
									color="primary"
									error={errors.password}
									variant="outlined"
									inputRef={register({
										required: {
											value: true,
											message: "Password tidak boleh kosong",
										},
										minLength: {
											value: 5,
											message: "Password tidak boleh kurang dari 5",
										},
										pattern: {
											value: /^[a-zA-Z0-9_.-]*$/,
											message:
												"Password harus berupa kombinasi huruf dan angka",
										},
									})}
									endAdornment={
										<InputAdornment position="end">
											<IconButton
												aria-label="toggle password visibility"
												onClick={handleClickShowPassword}
												onMouseDown={handleMouseDownPassword}
											>
												{values.showPassword ? (
													<Visibility />
												) : (
													<VisibilityOff />
												)}
											</IconButton>
										</InputAdornment>
									}
								/>
								{errors.password && (
									<Typography variant="caption" color="error">
										{errors.password.message}
									</Typography>
								)}
							</Grid>

							<Grid item xs={12} sm={12}>
								<ReactHookFormSelect
									id="role"
									name="role"
									// className={classes.textField}
									label="ID Role"
									control={control}
									error={errors.id}
									value={role}
									// handleOption={handleOption}
									// handleChange={handleChange}
									// rules={{
									//   required: {
									//     value: true,
									//     message: `Role tidak boleh kosong`,
									//   },
									// }}
									setState={setAddChange}
									state={addChange}
									variant="outlined"
									margin="normal"
									fullWidth
									required
								>
									<MenuItem value="none" disabled selected>
										--Pilih Role--
									</MenuItem>
									{option &&
										option.map((item, i) => (
											<MenuItem key={i} value={item.id}>
												{item.nama}
											</MenuItem>
										))}
								</ReactHookFormSelect>
								{errors.role && (
									<Typography variant="caption" color="error">
										{errors.role.message}
									</Typography>
								)}
							</Grid>

							<Grid item xs={12} sm={12}>
								<TextField
									id="telp"
									name="telp"
									label="Telepon"
									error={errors.telp}
									fullWidth
									placeholder="Type your Telepon"
									type="number"
									variant="outlined"
									required
									inputRef={register({
										minLength: {
											value: 10,
											message: "Minimal length phone number 10",
										},
										maxLength: {
											value: 14,
											message: "Maximal length phone number 14",
										},
									})}
									InputLabelProps={{ shrink: true }}
									helperText={errors.telp && errors.telp.message}
								/>
							</Grid>
						</Grid>
					</DialogContent>
					<DialogActions>
						<Button type="submit" color="primary">
							Add
						</Button>
						<Button onClick={handleClose} color="secondary">
							Cancel
						</Button>
					</DialogActions>
				</form>
			</Dialog>
		</div>
	);
}
